import { Settings } from '.generated/Feature.CW.model';
import AppliedFacetFilters from 'helpers/Coveo/AppliedFacetFilters';
import FacetGroup from 'helpers/Coveo/FacetGroup';
import {
  CoveoEngineProvider,
  useCoveoEngine,
} from 'lib/utils/coveo/SearchContext/CoveoEngineContext';
import { JSX, useEffect, useState } from 'react';
import { loadSearchActions, loadSearchAnalyticsActions } from '@coveo/headless';
import { useSiteSettings } from 'lib/utils/page-data-static-props/pageDataContext';

export type PageSettings = Settings.SiteSettings['fields'];

const BlogFacetsContent = (): JSX.Element => {
  const engine = useCoveoEngine();

  useEffect(() => {
    if (!engine) return;

    // Execute an initial search to populate facet values
    const { executeSearch } = loadSearchActions(engine);
    const { logInterfaceLoad } = loadSearchAnalyticsActions(engine);
    engine.dispatch(executeSearch(logInterfaceLoad()));
  }, [engine]);

  return (
    <>
      <FacetGroup
        fields={['cwblogcontenttype', 'cwcategory', 'cwagegroup']}
        labels={{
          cwblogcontenttype: 'Content Type',
          cwcategory: 'Topic',
          cwagegroup: 'Age/Life Stage',
        }}
        isIndependentFacet={true}
      />
      <AppliedFacetFilters
        fields={['cwblogcontenttype', 'cwcategory', 'cwagegroup']}
        labels={{
          cwblogcontenttype: 'Content Type',
          cwcategory: 'Topic',
          cwagegroup: 'Age/Life Stage',
        }}
      />
    </>
  );
};

const BlogFacets = (): JSX.Element => {
  const siteSettings = useSiteSettings()?.fields;

  const [coveoConfig, setCoveoConfig] = useState({
    searchHub: '',
    pipeline: '',
    accessToken: '',
    organizationId: '',
  });

  useEffect(() => {
    setCoveoConfig({
      searchHub: siteSettings?.blogSRSearchHub?.value || '',
      pipeline: siteSettings?.blogSRPipeline?.value || '',
      accessToken: siteSettings?.blogSRAccessToken?.value || '',
      organizationId: process.env.NEXT_PUBLIC_COVEO_ORG_ID || '',
    });
  }, [siteSettings]);

  // Don't render if no blog content type or missing Coveo config
  if (!coveoConfig?.organizationId || !coveoConfig?.accessToken || !coveoConfig?.pipeline) {
    return <></>;
  }

  return (
    <div className="w-full">
      <div className="max-w-screen-xxl mx-auto px-10 lg:px-[80px]">
        <CoveoEngineProvider config={coveoConfig}>
          <BlogFacetsContent />
        </CoveoEngineProvider>
      </div>
    </div>
  );
};

export default BlogFacets;
